<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                            <h1 class="display-3  text-white">What is Application Modernization?</h1>
                            <p class="lead text-justify text-white">Application Modernization is the practice of updating older software for newer computing approaches,including newer languages,frameworks and infrastructure platforms.This practice is also sometimes called legacy modernization or legacy application modernization
                            </p>
                            </div>
                        <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="@/assets/app.png" class="img-center img-fluid">
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-5 order-md-2">
                        <img src="img/theme/why-work-with-smakintel.jpg" class="img-fluid floating">
                    </div>
                    <div class="col-md-7 order-md-1">
                        <div class="pr-md-5">
                            
                                <h3>Application modernization Methods.</h3>
                                <h5>Common methods for modernizing applications include:</h5>
                            
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Lift and shift.</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">Refactoring.</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">Replatforming.</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container_card">
                <div class="row">
                   
                    <h2 class="text-black">Key Technologies for Application Modernization.</h2>
                     <h3>There are several intersecting technologies fundamental to application modernization.</h3>
                    <div class="col-lg-3">
                        <card class="card shadow-lg--hover mt-5" style="height:25rem; width:18rem">
                            <h6 class="text-success text-uppercase">Cloud Computing</h6>
                            <p class="description mt-3">When people discuss application modernization,
                            they are typically referring to the process of migrating traditional applications to run in modern cloud environments.
                            These include public cloud platforms, private clouds and hybrid clouds (which usually refer to public and/or private clouds integrated with on-premises environments).</p>
                        </card>
                    </div>
                    <div class="col-lg-3">
                        <card class="card shadow-lg--hover mt-5" style="height:25rem; width: 18rem">
                            <h6 class="text-success text-uppercase">Containers</h6>
                            <p class="description mt-3">Containers are a cloud-centric method for packaging, deploying and operating applications and workloads. 
                                The big-picture benefits associated with containerization include greater scalability, portability and operational efficiency that is well-suited for cloud infrastructure, and especially multi-cloud and hybrid cloud environments. </p>
                                    
                                    
                        </card>
                    </div>
                    <div class="col-lg-3">
                        <card class="card shadow-lg--hover mt-5" style="height:25rem;width: 18rem">
                            <h6 class="text-success text-uppercase">Microservices</h6>
                            <p class="description mt-3"> This is not so much a technology as an architectural choice. Instead of building and operating an application as a single, 
                            complete codebase—usually called a monolith, or monolithic development—you decouple different components into smaller, discrete pieces that can be deployed, updated and operated independently.</p>
                        </card>
                    </div>
                    <div class="col-lg-3">
                        <card class="card shadow-lg--hover mt-5" style="height:25rem width: 18rem">
                            <h6 class="text-success text-uppercase">Orchestration and Automation:</h6>
                            <p class="description mt-3">When people discuss application modernization,
                            they are typically referring to the process of migrating traditional applications to run in modern cloud environments.
                            These include public cloud platforms, private clouds and hybrid clouds (which usually refer to public and/or private clouds integrated with on-premises environments).</p>
                        </card>
                    </div>
                    </div>
                
            </div>
        </section>
        
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Start Your Next Project with SMAKINTEL.</h3>
                                <p class="lead text-white mt-3">We will be the leader of a company that ends up being
                                    worth billions of dollars, because We got the solutions. We understand culture.</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/#/contact-us"
                                             type="white" block size="lg">
                                    Contact Us
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
       
       

    </div>
</template>
<style scoped>
h6, h3{
    text-align: center;
}
.description{
    text-align: center;
   font-size:16px;
   font-family:Georgia, 'Times New Roman', Times, serif;
}

.container_card{
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    margin-right: auto;
    margin-left: auto;
    
}
.card{
border-bottom-left-radius: 10px;
border-top-left-radius: 10px;
border-bottom-right-radius: 10px;
border-top-right-radius: 10px;


margin-top: 10px;
margin-bottom: 10px;
flex: 1 1 auto;
flex-direction: column;
}
.row{
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}
</style>
<script>
export default {
  name: "home",
  components: {}
};
</script>
